import type { ReactNode } from 'react';
import type { HeadingLevel } from '@/lib/utils/headingLevel';

type RestProps = {
    level: HeadingLevel;
    id?: string;
    className?: string;
    children: ReactNode;
};

// Renders the heading tag for a given level; styling stays with the caller
// because the `heading-*` utilities are decoupled from the tag.
export function UiHeading({ level, id, className, children }: RestProps) {
    const Tag = `h${level}` as const;

    return (
        <Tag id={id} className={className}>
            {children}
        </Tag>
    );
}
